/**
 * Get special values refinement from dimensions
 * @param {Array} dimensions - Array of dimension objects
 * @returns {Object|undefined} Refinement object or undefined
 */
export const getSpecialValuesRefinement = (dimensions) => {
  const priceDimension = dimensions?.find((dimension) => dimension?.label === 'Price');
  return priceDimension?.refinements?.find((refinement) => refinement?.refinementKey === '7');
};

const SPECIAL_BUY_CONFIG = {
  key: 'specialbuy',
  label: 'Shop Savings',
  analytics: { categoryId: 'savings' },
  categoryId: 'savings',
  src: 'https://assets.thdstatic.com/images/special-buy--pod.jpg',
};

/**
 * Adds special savings navigation item if available
 * @param {Array} normalizedVisNavs - Array of normalized visual navigation items
 * @param {Object} dimensions - Dimensions data containing refinements
 * @returns {Array} Updated array with special savings item if applicable
 */
export const addSpecialSavingsToVisNav = (normalizedVisNavs, dimensions) => {
  const specialValues = getSpecialValuesRefinement(dimensions);

  if (!specialValues?.url) {
    return normalizedVisNavs;
  }

  return [
    ...normalizedVisNavs,
    {
      ...SPECIAL_BUY_CONFIG,
      url: specialValues.url,
    },
  ];
};

/**
 * Normalize visual navigation data
 * @param {Object} visualNav - Visual navigation object
 * @param {boolean} isMobile - Mobile view flag
 * @returns {Object} Normalized visual navigation object
 */
export const normalizeVisNav = (visualNav, isMobile, index) => {
  const PRODUCT_CATALOG_IMAGE_PATH = 'https://images.thdstatic.com/catalog/productImages';
  const size = isMobile ? 145 : 300;
  const {
    label, imageId, webUrl: url, categoryId, imageURL = ''
  } = visualNav;

  return {
    key: `${imageId || 'img'}-${index}`,
    url,
    label,
    analytics: { categoryId },
    categoryId,
    src: imageId
      ? `${PRODUCT_CATALOG_IMAGE_PATH}/${size}/${imageId.slice(0, 2)}/${imageId}_${size}.jpg`
      : imageURL,
  };
};
